interface Challenge {
  title: string;
  description: string;
}

interface ChallengesBlockProps {
  content: {
    title?: string;
    challenges?: Challenge[];
    showDivider?: boolean;
  };
}

export function ChallengesBlock({ content }: ChallengesBlockProps) {
  if (!content.challenges?.length) return null;

  return (
    <section className="mx-auto max-w-[1200px] px-6 py-20">
      {content.showDivider && <div className="mb-12 h-px w-16 bg-border" />}
      {content.title && (
        <h2 className="font-serif text-2xl md:text-3xl text-foreground mb-12">
          {content.title}
        </h2>
      )}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {content.challenges.map((challenge, i) => (
          <div key={i} className="border border-border bg-background p-8">
            <span className="font-serif text-4xl text-foreground/10 block mb-4">
              {String(i + 1).padStart(2, "0")}
            </span>
            <h3 className="font-serif text-lg text-foreground mb-3">
              {challenge.title}
            </h3>
            <p className="font-sans text-sm leading-relaxed text-muted-foreground">
              {challenge.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
